import script from "./ProfileAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileAvatar.vue?vue&type=style&index=0&id=d1339b40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1339b40"]])

export default __exports__